export function setTransparency(hex, alpha) {
  hex = hex.replace("#", "")
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map(c => c + c)
      .join("")
  }

  const num = parseInt(hex, 16)
  const r = (num >> 16) & 255
  const g = (num >> 8) & 255
  const b = num & 255

  const a = Math.min(1, Math.max(0, alpha))

  return `rgba(${r}, ${g}, ${b}, ${a})`
}
